module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAABWElEQVQ4T5WSzW2DQBCFZ1gOljhkLWHJ8u7BHYQSUoLTgdOBOwjpgA5iV2B3EEpwCT6wliUcQSRzW9hoEBB+7DjZCywz35uZxyBcOYkQXg7w6Cq1uRavv2E/mHDOteOECLA3AB4griZRFF4TGcCxlD4lTqLIpw40YoAACbtcXsZpmrZFOnAync5zxkJXqXk7KZaSKvv9DjrwWcodFMXaPR53NXxLkOINHEv5VKnTszlUFYsiaAsODIuF2NsAy7FS+zpIgmjMurq/9t0vK59nswVY1tKNokW76lmIAyK+W1pvcsbISOqqESnhei4DsLWz7I1c/RRiVf4qgNQQhLiytT7UIgZx2TGsAgjaIsAzyzKPhEo/jAkA4IPEc8ehd9qF7qElyR3HB2PCvkkt8XSilDeAf1vHckTOOYxGfHw6HX5mtm1y+aEHfzGtPUr803req3xzPf8DUu43zOOZ9byW3bwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon_t2.png
// module id = BX5Q
// module chunks = 85